import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { CONTACT } from "@/lib/data";

const ContactInfoCard = () => (
  <section
    className="py-20 lg:py-24 bg-white"
    data-testid="contact-info-card"
  >
    <div className="container-tm">
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-14">
        {/* Header */}
        <div className="lg:col-span-5">
          <p className="overline mb-3">Coordonnées</p>
          <h2 className="font-serif font-light text-ink text-3xl md:text-4xl lg:text-5xl leading-[1.05] tracking-tight">
            On peut aussi se{" "}
            <em className="text-gold">parler simplement</em>.
          </h2>
          <p className="mt-5 font-sans text-ink/65 text-base leading-relaxed">
            Vos coordonnées de référence pour nous joindre directement, à votre
            rythme. Une équipe locale, des humains au bout du fil, pas un
            standard téléphonique.
          </p>
        </div>

        {/* Info grid */}
        <div className="lg:col-span-7">
          <div className="grid sm:grid-cols-2 gap-4">
            {/* Phone */}
            <a
              href={CONTACT.phoneHref}
              data-testid="info-phone"
              className="group block bg-cream rounded-2xl p-6 border border-gold/15 hover:border-gold transition-colors duration-300"
            >
              <div className="w-11 h-11 rounded-xl bg-gold/15 text-gold flex items-center justify-center mb-4">
                <Phone size={18} strokeWidth={1.6} />
              </div>
              <p className="text-[10px] uppercase tracking-[0.22em] text-ink/45 font-semibold mb-2">
                Téléphone
              </p>
              <p className="font-serif text-2xl text-ink mb-1">
                {CONTACT.phone}
              </p>
              <p className="text-xs text-ink/55">Appel non surtaxé</p>
            </a>

            {/* Email */}
            <a
              href={`mailto:${CONTACT.email}`}
              data-testid="info-email"
              className="group block bg-cream rounded-2xl p-6 border border-gold/15 hover:border-gold transition-colors duration-300"
            >
              <div className="w-11 h-11 rounded-xl bg-gold/15 text-gold flex items-center justify-center mb-4">
                <Mail size={18} strokeWidth={1.6} />
              </div>
              <p className="text-[10px] uppercase tracking-[0.22em] text-ink/45 font-semibold mb-2">
                Email
              </p>
              <p className="font-sans text-sm text-ink leading-snug break-all">
                {CONTACT.email}
              </p>
              <p className="text-xs text-ink/55 mt-1">Réponse sous 24 h</p>
            </a>

            {/* Areas */}
            <div
              data-testid="info-areas"
              className="bg-cream rounded-2xl p-6 border border-gold/15"
            >
              <div className="w-11 h-11 rounded-xl bg-gold/15 text-gold flex items-center justify-center mb-4">
                <MapPin size={18} strokeWidth={1.6} />
              </div>
              <p className="text-[10px] uppercase tracking-[0.22em] text-ink/45 font-semibold mb-2">
                Zones d'intervention
              </p>
              <p className="font-serif text-base text-ink leading-snug mb-1">
                30 villes en Bretagne
              </p>
              <p className="text-xs text-ink/55 leading-relaxed">
                Saint-Malo · Côte d'Émeraude · Côtes-d'Armor · Morbihan
              </p>
            </div>

            {/* Hours */}
            <div
              data-testid="info-hours"
              className="bg-cream rounded-2xl p-6 border border-gold/15"
            >
              <div className="w-11 h-11 rounded-xl bg-gold/15 text-gold flex items-center justify-center mb-4">
                <Clock size={18} strokeWidth={1.6} />
              </div>
              <p className="text-[10px] uppercase tracking-[0.22em] text-ink/45 font-semibold mb-2">
                Horaires bureau
              </p>
              <ul className="space-y-1">
                {CONTACT.hours.map((h, i) => (
                  <li
                    key={i}
                    className="text-xs flex items-center justify-between gap-3"
                  >
                    <span className="font-medium text-ink">{h.day}</span>
                    <span className="text-ink/55">{h.slots}</span>
                  </li>
                ))}
              </ul>
              <p className="mt-3 text-[10px] text-gold uppercase tracking-[0.22em] font-semibold">
                Permanence voyageurs : 24h/24 · 7j/7
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default ContactInfoCard;
